import React from 'react';
import cx from 'classnames';

import './Tooltip.css';

interface TooltipProp {
  text?: string;
  htmlText?: string;
  className?: string;
  popIn?: boolean;
}

// htmlText is added in because sometimes tooltips require some words to be bold or have specific styling applied
const Tooltip = ({ text, htmlText, className, popIn }: TooltipProp): JSX.Element => (
  <div className={cx('zola-ui', 'tooltip__container', className)}>
    <div className={cx('tooltip', { 'pop-in': popIn })}>
      {text}
      {/* eslint-disable-next-line react/no-danger */}
      {htmlText && <span dangerouslySetInnerHTML={{ __html: `${htmlText}` }} />}
    </div>
  </div>
);

export default Tooltip;
